<template>
    <div class="d-flex align-center">
        <!-- DESKTOP -->
        <div v-if="$vuetify.display.mdAndUp" class="d-flex flex-wrap ga-2">
            <v-tooltip v-if="signatureInfo" location="top">
                <template #activator="{ props }">
                    <v-chip v-bind="props" class="mr-2" :color="signatureColor">
                        {{ signatureInfo || "N/A" }}
                    </v-chip>
                </template>
                <span>{{ signatureToolTip }}</span>
            </v-tooltip>

            <v-tooltip location="top">
                <template #activator="{ props }">
                    <v-chip v-bind="props" class="mr-2" :color="statusColor">
                        Status : {{ contractStatus || "N/A" }}
                    </v-chip>
                </template>

                <v-container class="pa-2">
                    <template v-if="lastHistoryEntry">
                        <p>
                            <strong>{{ lastHistoryEntry.field }}</strong>
                            {{ lastHistoryEntry.old_value }} →
                            {{ lastHistoryEntry.new_value }}
                        </p>
                        <p>
                            Modificat de:
                            <strong>{{ lastHistoryEntry.changed_by }}</strong>
                            la
                            <strong>{{
                                formatDate(lastHistoryEntry.changed_at)
                            }}</strong>
                        </p>
                    </template>
                    <p v-else class="text-center text-grey">
                        Nicio modificare înregistrată
                    </p>
                </v-container>
            </v-tooltip>
        </div>

        <!-- MOBILE -->
        <div v-else>
            <v-menu>
                <template #activator="{ props }">
                    <v-btn icon variant="plain" color="black" v-bind="props">
                        <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item>
                        <v-chip class="mr-2" :color="signatureColor">
                            {{ signatureInfo || "N/A" }}
                        </v-chip>
                    </v-list-item>
                    <v-list-item>
                        <v-chip class="mr-2" :color="statusColor">
                            Status : {{ contractStatus || "N/A" }}
                        </v-chip>
                    </v-list-item>
                </v-list>
            </v-menu>
        </div>
    </div>
</template>

<script>
export default {
    name: "ContractHeader",
    props: {
        signatureInfo: {
            type: String,
            default: "",
        },
        signatureToolTip: {
            type: String,
            default: "",
        },
        contractStatus: {
            type: String,
            default: "",
        },
        lastHistoryEntry: {
            type: Object,
            default: null,
        },
    },
    computed: {
        statusColor() {
            const status = String(this.contractStatus || "");

            if (
                [
                    "Factură avans achitată",
                    "Certificat de racordare",
                    "Factură finală",
                    "Decontare depusă",
                    "Decontat",
                ].includes(status)
            ) {
                return "orange";
            }

            switch (status) {
                case "Aprobat":
                    return "purple";
                case "Trimis":
                    return "blue";
                default:
                    return "gray";
            }
        },
        signatureColor() {
            if (!this.signatureInfo) return "default";
            if (this.signatureInfo.includes("Nesemnat")) return "error";
            if (this.signatureInfo.includes("Semnat")) return "success";
            return "default";
        },
    },
    methods: {
        formatDate(date) {
            if (!date) return "";
            return new Date(date).toLocaleString("ro-RO");
        },
    },
};
</script>
